module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg6@3x.6e4581b2.png";